export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $pinia } = useNuxtApp()
  const store = useStore($pinia)

  if (to.name === 'logout') {
    // const { isCanceled } = await confirmDialog.reveal({
    //   title: 'Do you want to logout?',
    //   description: `We'll miss you!`,
    //   type: 'info',
    // })

    // if (isCanceled) return abortNavigation()

    console.log('logout')
    localStorage.clear()
    sessionStorage.clear()
    store.auth = {}
    store.channels = []
    store.languages = []
    // store.$reset()

    if (to.path === '/logout') return navigateTo(`/login?redirect=${from.path}`)

    return navigateTo(`/login?redirect=${to.path}`)
  }

  if (!store.auth.authToken && to.name !== 'login') {
    if (to.path === '/logout') return navigateTo('/')

    return navigateTo(`/login?redirect=${to.path}`)
  }

  if (store.auth.authToken && to.name === 'login') {
    return navigateTo('/')
  }
})
